import { useGetCompleteYourLookLooks } from "../behaviors/useGetCompleteYourLookLooks";

const useShouldRedirectToCategoriesFromCompleteYourLook = () => {
  const { looks, isLoading } = useGetCompleteYourLookLooks();

  const shouldRedirectToCategoriesFromCYL = (looks === undefined || looks.length === 0) && isLoading === false;

  return { shouldRedirectToCategoriesFromCYL, isLoading };
};

export { useShouldRedirectToCategoriesFromCompleteYourLook };
